/**
 * @fileoverview Landing page navbar component
 */
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useLocation } from 'react-router-dom';

export const LandingNavbar = () => {
  const { t, currentLanguage, setLanguage, languages } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="landing-navbar">
      <div className="landing-navbar-content">
        <button
          className="mobile-menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          style={{ marginRight: '1rem' }}
        >
          <i className={isMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </button>

        <Link to="/" className="landing-logo">
          <img
            src="/logo_transparente.png"
            alt="TrueDok"
            style={{ height: '50px', objectFit: 'contain' }}
          />
        </Link>



        <div className="landing-auth-buttons" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="relative group">
            <button className="flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-all font-medium text-sm">
              <i className="fas fa-globe text-blue-500"></i>
              <span className="uppercase">{currentLanguage}</span>
              <i className="fas fa-chevron-down text-[10px] opacity-50 text-slate-400 group-hover:rotate-180 transition-transform"></i>
            </button>
            <div className="absolute top-full right-0 mt-2 w-40 bg-white rounded-xl shadow-xl border border-slate-100 py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => setLanguage(lang.code)}
                  className={`w-full text-left px-4 py-2 hover:bg-blue-50 transition-colors text-sm flex items-center justify-between ${currentLanguage === lang.code ? 'text-blue-600 font-bold bg-blue-50/50' : 'text-slate-600'
                    }`}
                >
                  {lang.native_name || lang.name}
                  {currentLanguage === lang.code && <i className="fas fa-check text-[10px]"></i>}
                </button>
              ))}
            </div>
          </div>


          <Link to="/register" className="px-5 py-2.5 rounded-lg bg-[#0575E6] text-white font-bold hover:bg-[#0460c4] transition-all shadow-md flex items-center gap-2">
            <i className="fas fa-user-plus"></i>
            {t('nav.register', 'Crear Cuenta')}
          </Link>
        </div>
      </div>

      <div className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu}>
        <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
          <div className="mobile-menu-header">
            <Link to="/" className="mobile-menu-logo" onClick={closeMenu}>
              <img
                src="/logo_transparente.png"
                alt="TrueDok"
                style={{ height: '40px', objectFit: 'contain' }}
              />
            </Link>
            <button className="mobile-menu-close" onClick={closeMenu}>
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="mobile-menu-auth">

            <Link to="/register" className="mobile-auth-button register" onClick={closeMenu}>
              <i className="fas fa-user-plus"></i>
              {t('nav.register', 'Crear Cuenta')}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};
